var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.color? 'langButton color-mobile' : 'langButton',attrs:{"id":"lang"},on:{"click":function($event){return _vm.toggleLang()}}},[_vm._v("fr")])
}
var staticRenderFns = []

export { render, staticRenderFns }